import React, { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';
import { useUserContext } from '@/modules/auth/hooks/useUser';

import { getTimeOfDay } from './utils';

function Greeting({ teachModeEnabled }: { teachModeEnabled: boolean }) {
  const timeOfDay = useMemo(() => getTimeOfDay(), []);
  const user = useUserContext();
  const { t } = useTranslation(['Coach', 'Common']);
  return (
    <Stack alignItems="center" direction="col">
      <Typography variant="display-s">{`${t('Coach:Good')}, ${t(
        'Coach:DayTime.' + timeOfDay,
      )}, ${user?.name}`}</Typography>
      <Typography color="text-text-secondary" variant="display-s">
        {teachModeEnabled
          ? t('KnowledgeBase.WhatDoYouWantToCoachMeAbout')
          : t('KnowledgeBase.WhatDoYouWantToTalkAbout')}
      </Typography>
    </Stack>
  );
}

export default Greeting;
